import ActionsForm from '@/shared/mixins/actionsForm'
import aprLogTemplate from '@/shared/http/repositories/business/aprLogTemplate'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'logApr',
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      serachiput: '',
      dataTemplateLogAPR: []
    }
  },

  props: ['aprId', 'templateClonado'],

  watch: {
    templateClonado (newValue) {
      if (newValue !== null || newValue !== undefined) {
        aprLogTemplate.GetAPRTemplateLogById(newValue.id)
          .then((Response) => {
            loading.pop()
            this.dataTemplateLogAPR = Response.data.data
          }).catch(Error => {
            loading.pop()
            toast.error('Erro ao carregar as informações')
          })
      }
    }
  },

  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      loading.push()
      aprLogTemplate.GetAPRTemplateLogById(this.aprId)
        .then((Response) => {
          console.log(Response.data.data)
          loading.pop()
          this.dataTemplateLogAPR = Response.data.data
        })
        .catch(Error => {
          loading.pop()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/logApr/logApr.js